import React, {useEffect, useState} from 'react';
import {Page} from '../../components/Page';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {useSnackbar} from 'notistack';
import {LoadingOverlay} from '../../components/LoadingOverlay/LoadingOverlay';
import getGroupByRef from './getGroupByRef.api';
import {makeStyles} from '@material-ui/styles';
import {Theme} from '@material-ui/core';
import {BookingToolContent} from './BookingTool';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(0),
        backgroundColor: theme.palette.white,
    },
}));

const AdminBookingTool = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const {id} = match.params;
    const classes = useStyles();
    const groupData = getGroupByRef(id);
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        if (groupData.error) {
            enqueueSnackbar(`There was an error loading the reference ${id}. Please contact admin@wcv.com`, {variant: 'error'});
            history.push('/');
        }
    }, [groupData.error]);

    return (
        <Page className={classes.root}>
            <LoadingOverlay loading={groupData.loading}>
                {groupData.data && groupData.data.groupByRef && (
                    <BookingToolContent adminVersion={true} group={groupData.data.groupByRef} />
                )}
            </LoadingOverlay>
        </Page>
    );
};


export default AdminBookingTool;
